/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Empty_DescriptionInputs */

const he_account_notifications_empty_description = /** @type {(inputs: Account_Notifications_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדר התראות בדפי המוצרים כדי לקבל עדכוני מחיר`)
};

const en_account_notifications_empty_description = /** @type {(inputs: Account_Notifications_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up notifications on item pages to get price alerts`)
};

/**
* | output |
* | --- |
* | "Set up notifications on item pages to get price alerts" |
*
* @param {Account_Notifications_Empty_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_empty_description = /** @type {((inputs?: Account_Notifications_Empty_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Empty_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_empty_description(inputs)
	return en_account_notifications_empty_description(inputs)
});